// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3-6ul","footer":"ChangeClinic_footer__2KMJP"};